<template lang="pug">
  Base(view_title="Autotask Connection")
    b-form(v-if="show_creds")
      b-form-group(label="API User")
        b-form-input(v-model="api_user")
      b-form-group(label="API Secret")
        b-form-input(v-model="api_secret")
      b-form-group(label="API Integration Code")
        b-form-input(v-model="api_integration_code")

      b-button( variant="success" @click="storeApiInfo" :disabled="busy") Save
        
      b-form-row
        small Your credentials are only stored on your browser, never on a server!
    
    b-button-group
      b-button( variant="primary" @click="toggleShowCredentials"  :disabled="busy") {{ show_creds ? "Hide" : "Show"}} Credentials
      b-button( v-if="has_api_info" variant="secondary" @click="loadAutotaskBaseCompany" :disabled="busy") Test Connection

    b-alert(show variant="secondary" v-if="busy") Checking connection...
    b-alert(show variant="warning" v-if="!busy && !is_connected") Currently disconnected from the Autotask REST API.
    b-alert(show variant="success" v-if="!busy && is_connected") Connected to the Autotask REST API.
    
</template>

<script>
import Base from '@/components/Base.vue'
import {mapGetters, mapMutations} from 'vuex'
import {doFetch, ApiError} from '@/lib/api'

export default {
  name: 'AdminHome',

  mixins: [],
  
  components: {
    Base,
  },
  
  props: {},

  data(){
    return {
      show_creds: false,
      api_user: "",
      api_secret: "",
      api_integration_code: "",
      autotask_result: null,
    };
  },

  computed:{
    ...mapGetters(["busy","error","errors","has_error","has_message","message"]),
    has_api_info(){
      return this.api_user && this.api_secret && this.api_integration_code
    },
    is_connected(){
      return this.has_api_info && this.autotask_result;
    }
  },

  created(){
    this.loadApiInfoFromStorage();
    if(this.has_api_info){
      this.loadAutotaskBaseCompany();
    } else {
      this.autotask_result = null;
    }
  },

  methods: {
    toggleShowCredentials(){
      this.show_creds = !this.show_creds;
    },
    ...mapMutations(["incrementInProcess","decrementInProcess","setError","setMessage"]),
    async storeApiInfo(){
      this.incrementInProcess();
      try{
        this.$offlineStorage.set('api_user', this.api_user);
        this.$offlineStorage.set('api_secret', this.api_secret);
        this.$offlineStorage.set('api_integration_code', this.api_integration_code);

        await this.loadAutotaskBaseCompany();
      }catch(ex){
        console.error(ex);
      }finally{
        this.decrementInProcess();
      }
      
    },
    loadApiInfoFromStorage(){
      this.api_user = this.$offlineStorage.get('api_user');
      this.api_secret = this.$offlineStorage.get('api_secret');
      this.api_integration_code = this.$offlineStorage.get('api_integration_code');
    },
    async loadAutotaskBaseCompany(){
      try{
        this.incrementInProcess();
      
        let result = await doFetch(null, {
          method: 'POST',
          headers: {
            'x-autotask-api-user': this.api_user,
            'x-autotask-api-secret': this.api_secret,
            'x-autotask-api-integration-code': this.api_integration_code,
          },
          url: `/autotask/Companies/get`,
          body: {
            id: 0
          }
        });

        if(!result.success){
          this.autotask_result = null;
        } else {
          this.autotask_result = result.response;
        }

      }catch(ex){
        if(ex instanceof ApiError){
          this.setError(`Problem invoking API. ${ex.message}`);
        }
        console.error(ex);
      }finally{
        this.decrementInProcess();
      }
      
    }
  },
}
</script>
